// extracted by mini-css-extract-plugin
module.exports = {"unit":"var(--ring-unit)","row":"RevisionRow__row--NE","root":"RevisionRow__root--Le","branch":"RevisionRow__branch--Wj","canChange":"RevisionRow__canChange--LY"};